import { useRequestHeaders } from "#imports";
import { HttpHeader } from "@backmarket/http-api/src/utils/types";
const WEBVIEW_USER_AGENT = "bm-mobile-app-webview";
export function useIsWebviewUserAgent() {
  const headers = useRequestHeaders();
  const userAgent = headers[HttpHeader.USER_AGENT] ?? window?.navigator?.userAgent;
  return Boolean(userAgent?.includes(WEBVIEW_USER_AGENT));
}
